import { v4 as uuid } from 'uuid';
import { useRef } from 'react';
import { FIELD_TYPES } from '../../constants/settings.constants';
import { useResourceInput } from '../../hooks/useResourceInput';
import Tooltip from '../core/Tooltip';
import SelectField from '../forms/SelectField';
import Switch from '../forms/Switch';
import TextArea from '../forms/TextArea';
import TextField from '../forms/TextField';

const AdminSchoolDetailsField = ({
  resource,
  field,
  options = [],
  value,
  agodiValue,
  onVisibilityChange,
  error,
  isManual,
  isSubmitting
}) => {
  const tooltipId = useRef(uuid()).current;
  const isSwitch = field.type === FIELD_TYPES.SWITCH;
  const isSelect = field.type === FIELD_TYPES.SELECT;
  const isDifferentThanAgodi = isManual ? false : value !== agodiValue;
  const inputProps = useResourceInput(field.field, resource, isSwitch ? false : undefined, {
    ignoreTouched: isSwitch,
    isSwitch
  });
  const sharedProps = {
    label: field.label,
    disabled: isSubmitting,
    isSubmitting,
    error,
    validationError: error,
    required: field.required,
    hasWarning: isDifferentThanAgodi
  };
  const overrideProps = {
    description:
      !error && (inputProps.description || isDifferentThanAgodi) ? (
        <span>
          Komt niet overeen met{' '}
          <span
            className="u-text-primary u-text-underline u-cursor-help"
            data-for={tooltipId}
            data-tip={`AGODI data: ${
              isSelect
                ? agodiValue === true
                  ? 'Ja'
                  : agodiValue === false
                  ? 'Nee'
                  : agodiValue || ''
                : agodiValue ?? ''
            }`}
          >
            AGODI data.
          </span>
        </span>
      ) : (
        error || ''
      )
  };

  let FieldComponent = null;
  switch (field.type) {
    case FIELD_TYPES.SELECT:
      FieldComponent = <SelectField {...sharedProps} {...inputProps} {...overrideProps} options={options} />;
      break;
    case FIELD_TYPES.TEXT_AREA:
      FieldComponent = <TextArea {...sharedProps} {...inputProps} {...overrideProps} />;
      break;
    case FIELD_TYPES.SWITCH:
      FieldComponent = (
        <Switch
          {...sharedProps}
          {...inputProps}
          {...overrideProps}
          validationError={inputProps.validationError || sharedProps.validationError}
          checked={value}
          onClick={field.field === 'isVisible' ? onVisibilityChange : inputProps.onSubmit}
          tip={field.tip}
          tipOffsetTop={96}
        />
      );
      break;

    default:
      FieldComponent = <TextField {...inputProps} {...overrideProps} {...sharedProps} />;
      break;
  }

  return (
    <div
      key={field.field}
      className={`${field.field === 'remarks' ? 'col-xs-12' : 'col-xs-12 col-md-6 col-lg-3 u-margin-bottom-md'}`}
    >
      {FieldComponent}
      <Tooltip id={tooltipId} />
    </div>
  );
};

export default AdminSchoolDetailsField;
